import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Tooltip from 'components/tooltips/Tooltip';
import SquareEditOutlineIcon from 'mdi-react/SquareEditOutlineIcon';


class ScheduleBtn extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    toggle: PropTypes.func.isRequired,
  };

  static defaultProps = {
    className: '',
  };

  clickIcon = (event) => {
    // Prevents tooltip to keep appearing when modal closes
    event.currentTarget.blur();
    this.props.toggle();
  }

  render() {
    return (
      <Tooltip
        placement="left"
        title="Manage Schedules"
      >
        <div className={this.props.className}>
          <SquareEditOutlineIcon
            id="scheduleOptionsTooltipLeft"
            onClick={this.clickIcon}
          />
        </div>
      </Tooltip>
    );
  }
}

export default ScheduleBtn;
